import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebTransaction } from "../../../models";

@Component({
    selector: "app-transactions-dialog",
    templateUrl: "./transactions-dialog-component.html",
    styleUrls: ["./transactions-dialog.component.scss"],
})
export class TransactionsDialogComponent
{

    transaction: WebTransaction;

    constructor(
        public dialogRef: MatDialogRef<TransactionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data)
    {
        this.transaction = data.transaction;
    }
}
